class RelatedProducts extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newEl = doc.querySelector('related-products');
        if (newEl && newEl.innerHTML.trim() !== '') {
          this.innerHTML = newEl.innerHTML;
        } else {
          this.remove();
        }
      })
      .catch(() => this.remove());
  }
}
customElements.define('related-products', RelatedProducts);
